/** Must match server `prod/constants/partUnitConditions.js` values */
export const PART_UNIT_CONDITIONS = [
  'NEW',
  'SERVICEABLE',
  'UNSERVICEABLE',
  'REPAIRED',
  'INSPECTED_OR_TESTED',
  'OVERHAUL_UNIT',
  'AIRCRAFT_REMOVED',
  'GOOD',
  'DAMAGED',
  'DEFECTIVE'
];

export const RECEIVING_PRIMARY_CONDITIONS = [
  'NEW',
  'SERVICEABLE',
  'UNSERVICEABLE',
  'REPAIRED',
  'INSPECTED_OR_TESTED',
  'OVERHAUL_UNIT',
  'AIRCRAFT_REMOVED'
];

export const LEGACY_PART_CONDITIONS = ['GOOD', 'DAMAGED', 'DEFECTIVE'];

export const PART_CONDITION_LABELS = {
  NEW: 'New',
  SERVICEABLE: 'Serviceable',
  UNSERVICEABLE: 'Unserviceable',
  REPAIRED: 'Repaired',
  INSPECTED_OR_TESTED: 'Inspected or tested',
  OVERHAUL_UNIT: 'Overhaul unit',
  AIRCRAFT_REMOVED: 'Aircraft removed',
  GOOD: 'Good (legacy)',
  DAMAGED: 'Damaged (legacy)',
  DEFECTIVE: 'Defective (legacy)'
};

export function formatPartConditionLabel(code) {
  if (!code) return '—';
  return PART_CONDITION_LABELS[code] || String(code).replace(/_/g, ' ');
}

/** Value safe for MUI Select (must be a known enum or default). */
export function partConditionSelectValue(raw) {
  return PART_UNIT_CONDITIONS.includes(raw) ? raw : 'SERVICEABLE';
}

/** Unit-detail row count for a received quantity (supports fractional qty < 1). */
export function receivingUnitDetailCount(rawQty) {
  const qty = Math.max(0, Number(rawQty) || 0);
  if (qty <= 0) return 0;
  return qty > 0 && qty < 1 ? 1 : Math.floor(qty);
}

/** Line-level condition for submit/inventory: unanimous unit condition wins over line dropdown. */
export function deriveReceivingLineCondition(line) {
  const unitDetails = Array.isArray(line?.unitDetails) ? line.unitDetails : [];
  if (unitDetails.length > 0) {
    const unique = [...new Set(unitDetails.map((unit) => partConditionSelectValue(unit?.condition)))];
    if (unique.length === 1) return unique[0];
  }
  return partConditionSelectValue(line?.condition);
}
